const SharedRouter = [
  {
    path    : '/',
    redirect: '/account/create/agree',
  },
  {
    path     : '/not-found',
    component: () => import('@/app/layout/view/layout-not-found.vue'),
  },
  {
    path    : '*',
    redirect: '/not-found',
  }
];

export default SharedRouter;
